import React, {useState} from "react";


const Sidebar = () => {
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.menu-item').forEach(item => {
        item.addEventListener('mouseenter', function () {
            let submenu = this.querySelector('.submenu');
            if (submenu) {
                let rect = this.getBoundingClientRect(); // Get position of parent
                submenu.style.top = rect.top + "px"; // Align submenu to its parent
                submenu.style.left = rect.right + "px"; // Move it outside sidebar
            }
        });
    });
});

    const [isCollapsed, setIsCollapsed] = useState(false);
    const [openMenus, setOpenMenus] = useState({});
    const toggleSubMenu = (index) => {
      setOpenMenus((prevState) => ({
          ...prevState,
          [index]: !prevState[index],
      }));
  };
  return (
    <div className={`nk-sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="nk-nav-scroll">
                {/* <ul>
                  <li className="hamburger"  onClick={() => setIsCollapsed(!isCollapsed)}>
                    <span className="toggle-icon">
                      <i className="icon-arrow-right"></i>
                    </span>
                  </li>
                </ul> */}
               
              <ul className="metismenu" id="menu">
                {menuItems.map((item, index) =>  {
                    if (item.menu === localStorage.getItem("play")) {
                      console.log(item.menu);
                      return(
                    <li key={index} className={isCollapsed ? "collapsed-menu-item" : ""}>
                        <a
                            className={item.subItems.length ? "has-arrow" : ""}
                            href={item.link}
                            onClick={(e) => {
                              if (item.subItems.length > 0) {
                                e.preventDefault();
                                toggleSubMenu(index);
                              }
                            }}
                            aria-expanded={openMenus[index] ? "true" : "false"}
                        >
                            <i className={item.icon}></i>
                            {!isCollapsed && <span className="nav-text">{item.label}</span>}
                        </a>
                        {item.subItems.length > 0 && (
                            <ul
                                className={`submenu ${isCollapsed ? "collapsed-submenu" : ""}`}
                                style={{ display: openMenus[index] ? "block" : "none" }}
                            >
                                {item.subItems.map((subItem, subIndex) => (
                                    
                                    <li key={subIndex}><a href={subItem.link}>{subItem.label}</a></li>
                                ))}
                            </ul>
                        )}
                    </li>
                    );
                  } 
                    return null;
                })}
        </ul>

               
                </div>
    </div>
  );
};
const menuItems = [
    {
        label: "Dashboard",
        icon: "icon-speedometer menu-icon",
        menu: "employer",
        link: "/home",
        subItems: [],
    },
    {
      label: "Company Profile",
      icon: "icon-envelope menu-icon",
      menu: "employer",
      link: "/company/company-profile/profile",
      subItems: [],
      // subItems: [
      //   { label: "Company Information", link: "/company/company-profile/profile" },
      //   { label: "Upload Logo & Cover", link: "./email-read.html" },
      //   { label: "Specializations & Industry", link: "./email-compose.html" },
      // ],
    },
    {
      label: "Job Management",
      icon: "icon-grid menu-icon",
      menu: "employer",
      subItems: [
        { label: "All Job Postings", link: "/employer/job-management/all-jobs" },
        { label: "Your Job Postings", link: "/employer/job-management/your-jobs" },
        // { label: "Post a Job", link: "./ui-alert.html" },
        // { label: "Edit or Remove Jobs", link: "./ui-badge.html" },
      ],
    },
    {
      label: "Applications",
      icon: "icon-note menu-icon",
      menu: "employer",
      subItems: [
        { label: "View All Applicants", link: "/employer/applications/view" },
        // { label: "Saved Candidates", link: "./form-validation.html" },
        // { label: "Resume Search & Filtering", link: "./form-step.html" },
      ],
    },
    // {
    //   label: "ATS",
    //   icon: "icon-menu menu-icon",
    //   menu: "employer",
    //   subItems: [
    //     { label: "Track Applications", link: "./table-basic.html" },
    //     { label: "Manage Interviews & Tests", link: "./table-datatable.html" },
    //   ],
    // },
    // {
    //   label: "Hiring",
    //   icon: "icon-notebook menu-icon",
    //   menu: "employer",
    //   subItems: [
    //     { label: "Schedule Interviews", link: "./page-login.html" },
    //     { label: "Live & Pre-Recorded Interviews", link: "./page-register.html" },
    //     { label: "Candidate Assessments & Tests", link: "./page-lock.html" },
    //     { label: "Offer Management & Negotiations", link: "./page-lock.html" },
    //   ],
    // },
    // {
    //   label: "Subscription",
    //   icon: "icon-notebook menu-icon",
    //   menu: "employer",
    //   subItems: [
    //     { label: "Subscription Plans", link: "./page-login.html" },
    //     { label: "Featured & Sponsored Jobs", link: "./page-register.html" },
    //     { label: "Payment History & Invoices", link: "./page-lock.html" },
    //   ],
    // },
    // {
    //   label: "Notifications & Messages",
    //   icon: "icon-notebook menu-icon",
    //   menu: "employer",
    //   subItems: [
    //     { label: "In-App Notifications", link: "./page-login.html" },
    //     { label: "Chat with Candidates", link: "./page-register.html" },
    //     { label: "Email & SMS Alerts", link: "./page-lock.html" },
    //   ],
    // },
    // {
    //   label: "Reports & Analytics",
    //   icon: "icon-notebook menu-icon",
    //   menu: "employer",
    //   subItems: [
    //     { label: "Job Performance Reports", link: "./page-login.html" },
    //     { label: "Hiring Efficiency Metrics", link: "./page-register.html" },
    //     { label: "Candidate Insights", link: "./page-lock.html" },
    //   ],
    // },
    // {
    //   label: "Referral & Affiliate Program",
    //   icon: "icon-notebook menu-icon",
    //   menu: "employer",
    //   subItems: [
    //     { label: "Referral Bonuses", link: "./page-login.html" },
    //     { label: "Affiliate Partnerships", link: "./page-register.html" },
    //   ],
    // },
    {
      label: "Dashboard",
      icon: "icon-speedometer menu-icon",
      menu: "admin",
      subItems: [],
    },
    {
      label: "User & Role Management",
      icon: "icon-envelope menu-icon",
      menu: "admin",
      subItems: [
        { label: "Manage Employers", link: "./email-inbox.html" },
        { label: "Manage Job Seekers", link: "./email-read.html" },
        { label: "Role-Based Access Control", link: "./email-compose.html" },
        { label: "User Activity Logs", link: "./email-compose.html" },
      ],
    },
    {
      label: "Content Moderation",
      icon: "icon-grid menu-icon",
      menu: "admin",
      subItems: [
        { label: "Approve/Reject Job Listings", link: "./ui-accordion.html" },
        { label: "Review Resume & Profile Reports", link: "./ui-alert.html" },
        { label: "Moderate Employer & Job Seeker Reviews", link: "./ui-badge.html" },
      ],
    },
    {
      label: "Job & Application Management",
      icon: "icon-note menu-icon",
      menu: "admin",
      subItems: [
        { label: "View Job Listings", link: "./form-basic.html" },
        { label: "Manage Reported Jobs", link: "./form-validation.html" },
        { label: "Oversee Job Applications", link: "./form-step.html" },
      ],
    },
    {
      label: "Security & Fraud Detection",
      icon: "icon-menu menu-icon",
      menu: "admin",
      subItems: [
        { label: "Monitor Suspicious Activity", link: "./table-basic.html" },
        { label: "Manage User Complaints & Reports", link: "./table-datatable.html" },
        { label: "Suspend/Block Accounts", link: "./table-datatable.html" },
      ],
    },
    {
      label: "API & Third-Party Integrations",
      icon: "icon-notebook menu-icon",
      menu: "admin",
      subItems: [
        { label: "Configure Social Logins", link: "./page-login.html" },
        { label: "Integrate ATS & Resume Parsing APIs", link: "./page-register.html" },
        { label: "Manage Google Jobs & Indeed Posting", link: "./page-lock.html" },
      ],
    },
  ];
export default Sidebar;
